@if (icon(); as icon) {
  <div class="icon-container">
    <nb-icon [config]="icon"></nb-icon>
  </div>
}

@if (toast().config.hasCloseBtn) {
  <button class="close-button hover-able" type="button">
    <nb-icon icon="close" (click)="$event.stopPropagation(); onClick()" />
  </button>
}

<div class="content-container">
  @if (title(); as title) {
    <span class="title">{{ title }}</span>
  }
  <div class="message">{{ message() }}</div>
</div>
